// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Maersk Text ;
}


.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.HeaderStyle{
  box-shadow: 0 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .2)), 0 4px 5px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .14)), 0 1px 10px 0 var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, .12));

  
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Global font family */
body {
  font-family: 'Maersk Text' !important;
  margin: 0;
  padding: 0;
}

/* Heading font size */
h1, h2, h3, h4, h5, h6 {
  font-family: 'Maersk Text' !important;
  font-size: 14px;
}

/* Default font size for other text elements */
p, td, th, div, span, input, select {
  font-size: 10px;
  font-family: 'Maersk Text' ;
}

/* Style for table */
table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Maersk Text' !important;
}

/* Table header styling */
th {
  font-size: 12px !important;
  font-family: 'Maersk Text' !important;
  background-color: rgb(66, 176, 213); /* Optional: adds a background color to the header */
  padding: 3px !important;
  text-align: left;
  border-bottom: 1px solid #ddd;
  color: white !important;
  font-weight: bold !important;
  text-align: center !important;
}

/* Table data cell styling */
td {
  font-size: 10px !important;
  font-family: 'Maersk Text' !important;
  padding: 3px !important;
  border-bottom: 1px solid #ddd;
}

/* Adjusting padding and alignment for table cells */
td, th {
  padding: 3px !important;
  font-family: 'Maersk Text' !important;
  text-align: left;
}

/* React Select dropdown styling (if you use it for filtering) */
.react-select__option, .react-select__single-value {
  font-size: 12px !important;
  font-family: 'Maersk Text' !important;
}

.custom-date-range input {
  height: 40px !important;
}

.ProjectStatusTable thead tr th {

  background-color: #ededed !important;
  color: grey !important;
  padding:0px !important;
}

.OpportunitiesContainer{
  height:600px;
   width: 100%; 
   .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root {
    display: none;
   }

}

@media only screen and (min-width: 1439px) {
  .OpportunitiesContainer{
    height:calc(100vh - 300px);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,2NAA2N;;;AAG7N;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,SAAS;EACT,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,mCAAmC,EAAE,oDAAoD;EACzF,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;GACX,WAAW;GACX;IACC,aAAa;GACd;;AAEH;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["* {\n  font-family: Maersk Text ;\n}\n\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.HeaderStyle{\n  box-shadow: 0 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .2)), 0 4px 5px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .14)), 0 1px 10px 0 var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, .12));\n\n  \n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Global font family */\nbody {\n  font-family: 'Maersk Text' !important;\n  margin: 0;\n  padding: 0;\n}\n\n/* Heading font size */\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Maersk Text' !important;\n  font-size: 14px;\n}\n\n/* Default font size for other text elements */\np, td, th, div, span, input, select {\n  font-size: 10px;\n  font-family: 'Maersk Text' ;\n}\n\n/* Style for table */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Maersk Text' !important;\n}\n\n/* Table header styling */\nth {\n  font-size: 12px !important;\n  font-family: 'Maersk Text' !important;\n  background-color: rgb(66, 176, 213); /* Optional: adds a background color to the header */\n  padding: 3px !important;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n  color: white !important;\n  font-weight: bold !important;\n  text-align: center !important;\n}\n\n/* Table data cell styling */\ntd {\n  font-size: 10px !important;\n  font-family: 'Maersk Text' !important;\n  padding: 3px !important;\n  border-bottom: 1px solid #ddd;\n}\n\n/* Adjusting padding and alignment for table cells */\ntd, th {\n  padding: 3px !important;\n  font-family: 'Maersk Text' !important;\n  text-align: left;\n}\n\n/* React Select dropdown styling (if you use it for filtering) */\n.react-select__option, .react-select__single-value {\n  font-size: 12px !important;\n  font-family: 'Maersk Text' !important;\n}\n\n.custom-date-range input {\n  height: 40px !important;\n}\n\n.ProjectStatusTable thead tr th {\n\n  background-color: #ededed !important;\n  color: grey !important;\n  padding:0px !important;\n}\n\n.OpportunitiesContainer{\n  height:600px;\n   width: 100%; \n   .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root {\n    display: none;\n   }\n\n}\n\n@media only screen and (min-width: 1439px) {\n  .OpportunitiesContainer{\n    height:calc(100vh - 300px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
